var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComposeAppIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "129px",
    height: "54px",
    viewBox: "0 0 129 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 115,
    height: 40,
    rx: 20
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.1%",
    y: "-21.2%",
    width: "118.3%",
    height: "152.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196078   0 0 0 0 0.729411765   0 0 0 0 0.77254902  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockup-13",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HO-Blurb-dash",
    transform: "translate(-238.000000, -1431.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(245.000000, 1436.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#CCCCCC",
    strokeWidth: 1,
    fill: "#F7F7F7",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14,22.0837384 L14,25 L16.9162616,25 L25.5172893,16.3989724 L22.6010276,13.4827107 L14,22.0837384 Z M27.7725316,14.14373 C28.0758228,13.8404388 28.0758228,13.3505069 27.7725316,13.0472157 L25.9527843,11.2274684 C25.6494931,10.9241772 25.1595612,10.9241772 24.85627,11.2274684 L23.4331343,12.6506041 L26.3493959,15.5668657 L27.7725316,14.14373 Z",
    id: "Shape",
    fill: "#7A7A70",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Compose",
    transform: "translate(38.532000, 13.144000)",
    fill: "#00142D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.928,0 C2.142,0 0,2.128 0,5.054 C0,7.98 1.988,10.164 4.928,10.164 C7.266,10.164 8.624,8.974 9.45,7.224 L8.134,7.224 C7.63,8.358 6.552,9.128 4.984,9.128 C2.772,9.128 1.204,7.35 1.204,5.068 C1.204,2.436 3.01,1.036 4.914,1.036 C6.482,1.036 7.532,1.778 7.994,2.758 L9.31,2.758 C8.792,1.54 7.56,0 4.928,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.668,6.496 C10.668,8.526 12.222,10.094 14.252,10.094 C16.324,10.094 17.836,8.47 17.836,6.496 C17.836,4.466 16.338,2.926 14.252,2.926 C12.236,2.926 10.668,4.424 10.668,6.496 Z M11.816,6.496 C11.816,5.012 12.824,3.92 14.252,3.92 C15.722,3.92 16.688,5.082 16.688,6.496 C16.688,7.966 15.666,9.086 14.252,9.086 C12.964,9.086 11.816,8.008 11.816,6.496 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.306,9.856 L20.412,9.856 L20.412,6.132 C20.412,4.732 21.126,3.92 22.246,3.92 C23.24,3.92 23.842,4.76 23.842,5.866 L23.842,9.856 L24.962,9.856 L24.962,6.132 C24.962,4.592 25.844,3.92 26.782,3.92 C27.916,3.92 28.392,4.83 28.392,5.866 L28.392,9.856 L29.498,9.856 L29.498,5.95 C29.498,3.976 28.448,2.926 26.936,2.926 C25.774,2.926 24.962,3.64 24.626,4.312 C24.346,3.528 23.492,2.926 22.442,2.926 C21.574,2.926 20.888,3.388 20.44,3.99 L20.412,3.99 L20.412,3.15 L19.306,3.15 L19.306,9.856 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.346,13.146 L32.452,13.146 L32.452,8.96 L32.48,8.96 C32.97,9.548 33.81,10.094 34.958,10.094 C36.918,10.094 38.374,8.526 38.374,6.496 C38.374,4.676 37.142,2.926 35,2.926 C33.642,2.926 32.928,3.57 32.48,4.102 L32.452,4.102 L32.452,3.15 L31.346,3.15 L31.346,13.146 Z M37.226,6.496 C37.226,7.784 36.414,9.114 34.79,9.114 C33.502,9.114 32.354,8.064 32.354,6.538 C32.354,4.942 33.418,3.892 34.762,3.892 C36.414,3.892 37.226,5.194 37.226,6.496 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.382,6.496 C39.382,8.526 40.936,10.094 42.966,10.094 C45.038,10.094 46.55,8.47 46.55,6.496 C46.55,4.466 45.052,2.926 42.966,2.926 C40.95,2.926 39.382,4.424 39.382,6.496 Z M40.53,6.496 C40.53,5.012 41.538,3.92 42.966,3.92 C44.436,3.92 45.402,5.082 45.402,6.496 C45.402,7.966 44.38,9.086 42.966,9.086 C41.678,9.086 40.53,8.008 40.53,6.496 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.29,4.76 C52.066,3.766 51.408,2.926 50.036,2.926 C48.664,2.926 47.936,3.766 47.936,4.746 C47.936,5.754 48.524,6.384 49.784,6.79 C51.03,7.196 51.282,7.574 51.282,8.148 C51.282,8.708 50.904,9.142 50.162,9.142 C49.336,9.142 48.93,8.652 48.804,8.064 L47.684,8.064 C47.894,9.226 48.636,10.094 50.12,10.094 C51.492,10.094 52.388,9.296 52.388,8.064 C52.388,7.168 51.926,6.398 50.442,5.922 C49.224,5.53 49.028,5.18 49.028,4.76 C49.028,4.27 49.406,3.864 50.092,3.864 C50.624,3.864 51.058,4.242 51.17,4.76 L52.29,4.76 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.84,2.926 C54.81,2.926 53.508,4.564 53.508,6.412 C53.508,8.498 54.936,10.094 57.064,10.094 C58.646,10.094 59.584,9.142 60.032,8.302 L58.758,8.302 C58.324,8.82 57.834,9.114 57.036,9.114 C55.776,9.114 54.656,8.036 54.656,6.818 L60.13,6.818 C60.144,6.748 60.158,6.538 60.158,6.412 C60.158,4.942 59.276,2.94 56.84,2.926 Z M56.84,3.892 C58.058,3.892 58.884,4.844 58.996,5.894 L54.67,5.894 C54.768,4.872 55.566,3.892 56.84,3.892 Z",
    id: "Shape"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComposeAppIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/compose_appIcon.12957a77b78a2e3e69cecd3baf59657f.svg";